<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false">
    <el-form ref="editForm" :model="app" label-width="100px" :rules="validateRules">
        <el-form-item label="版本号" prop="versionName">
          <el-input type="text" v-model="app.versionName" maxlength="15" placeholder="如1.2.0"></el-input>
        </el-form-item>
        <el-form-item label="硬件程序文件" prop="fileList">
          <el-upload ref="uploader" name="mfile"
                     :auto-upload="false"
                     :multiple="false"
                     :with-credentials="true"
                     :on-success="onSuccess"
                     :on-error="onError"
                     :before-upload="onUpload"
                     :data="app"
                     :action="globalConfig.apiRoot+'/boot-version/upload'">
            <el-button type="primary">上传</el-button>
          </el-upload>
        </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button type="default" @click="close">取消</el-button>
      <el-button type="primary" @click="save" icon="fa fa-upload" :loading="loading">上传</el-button>
    </template>
  </el-dialog>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";

export default {
  name: "BootUpload",
  extends: BaseVue,
  data() {
    return {
      app: {
        versionName: null
      },
      validateRules: {
        versionName: [{required: true, trigger:'blur', message:'版本名称不能为空'}]
      }
    }
  },
  created() {
  },
  methods: {
    save() {
      let editForm = this.$refs["editForm"];
      editForm.validate((yes)=>{
        if(yes){
          let uploader = this.$refs["uploader"];
          uploader.submit();
        }
      })
    },
    close() {
      this.$emit("close");
    },
    onSuccess(dr) {
      this.loading = false;
      if(dr.success) {
        this.$message.info("上传成功");
        this.$emit("save");
      } else {
        this.$message.error(dr.msg);
      }
    },
    onError(e) {
      this.loading = false;
      this.$message.error("上传文件失败");
    },
    onUpload(file) {
      this.loading = false;
      if(!file) {
        this.$message.warning("请选择APK文件");
        return false;
      }
      return true;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>